<script>
import { mapActions } from 'vuex';
import price from '@phoenix/mixins/price';
import ProductPrice from '@phoenix/components/common/ProductPrice';
import PictureLazy from '@maison/components/common/PictureLazy';
import WishlistButton from '@maison/components/wishlist/WishlistButton';
import { PhxIcon } from '@phx-styleguides/pia';

export default {
  components: {
    ProductPrice,
    WishlistButton,
    PictureLazy,
    PhxIcon,
  },

  mixins: [price],

  props: {
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    modelReference: {
      type: String,
      required: true,
    },
    imageProductKey: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    price: {
      type: [String, Object],
      default: '',
    },
    id: {
      type: String,
      default: null,
    },
    tracking: {
      type: Object,
      default: null,
    },
    shouldDisplayPrice: {
      type: Boolean,
      default: true,
    },
    shouldDisplayRemoveFromCart: {
      type: Boolean,
      default: false,
    },
    shouldDisplayRemoveFromWishlist: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    ...mapActions('wishlist', ['toggleProduct']),
    ...mapActions('cartPreview', ['removeProduct']),
  },
};
</script>

<template>
  <div class="product-card-key">
    <div class="product-card-key__media">
      <div class="picture picture--block">
        <picture-lazy v-bind="imageProductKey"></picture-lazy>
      </div>
    </div>

    <div>
      <a :href="url" class="product-card-key__title expand-target">{{ name }}</a>
      <div v-if="description" class="product-card-key__subtitle">
        {{ description }}
      </div>
      <div v-if="shouldDisplayPrice">
        <div v-if="price" class="product-card-key__price">
          <product-price v-if="typeof price === 'object'" v-bind="localizePrice(price)"></product-price>
          <template v-else>{{ price }}</template>
        </div>
        <div v-else class="product-card-key__price">
          {{ $t('Product.priceOnDemand') }}
        </div>
      </div>
    </div>

    <div class="product-card-key__actions">
      <wishlist-button
        v-if="shouldDisplayRemoveFromWishlist"
        :name="name"
        :reference="modelReference"
        default-in-wishlist-icon="close"
        :new-styleguide="true"
      ></wishlist-button>

      <button
        v-if="shouldDisplayRemoveFromCart"
        class="btn btn--sm btn--icon-only btn--tertiary btn--circle"
        type="button"
        :title="$t('Checkout.removeProduct', { product: name })"
        data-cy="cart-summary-remove-btn"
        @click.stop="removeProduct({ id: id, tracking: tracking })"
      >
        <span class="btn__icon btn__icon--start">
          <phx-icon icon="cross" class="icon--xs" />
        </span>
      </button>

      <slot name="action"></slot>
    </div>
  </div>
</template>
